/**
 * Hero copy, in one place (DWEB-14).
 *
 * It used to live as literals inside Hero.js's JSX, which was fine until the
 * build-time prerenderer needed the same words. Two copies of the headline —
 * one rendered, one prerendered — is exactly the drift this repo keeps paying
 * for elsewhere, so the words moved here and both readers import them.
 *
 * KEEP THIS MODULE FREE OF IMPORTS. scripts/prerenderContent.mjs loads it by
 * copying the file to a .mjs and importing it from plain node — no webpack, no
 * JSX, no transpile. An import of anything React-shaped would break that.
 *
 * The title is split because the rendered version wraps the middle in a
 * highlight span. textContent is unchanged by that span, so HERO_TITLE is the
 * string the h1 actually reads — which is what the suite and the crawler see.
 */

export const HERO_TITLE_LEAD = "Your domain's product vision, shipped as ";
export const HERO_TITLE_HIGHLIGHT = 'production reality';
export const HERO_TITLE_TAIL = '.';

export const HERO_TITLE = `${HERO_TITLE_LEAD}${HERO_TITLE_HIGHLIGHT}${HERO_TITLE_TAIL}`;

export const HERO_PARAGRAPH =
  'Accountable technical leadership for domain-expert founders and teams — ' +
  'design, guidance, and delivery that honor the domain without compromising ' +
  'the engineering.';
